import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20" aria-labelledby="cta-title">
      <div className="w-full px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <h2 id="cta-title" className="text-3xl md:text-5xl font-black text-foreground-950 mb-3">
            不想错过任何爆料？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            订阅我们的每日爆料推送，第一时间掌握最新吃瓜资讯
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-secondary-500 text-white font-semibold text-sm hover:bg-secondary-600 cursor-pointer transition-all whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>

        {/* Bottom decorative image strip */}
        <div className="mt-12 overflow-hidden">
          <div className="flex gap-3 opacity-20">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="flex-shrink-0 w-32 h-20 md:w-40 md:h-24 rounded-lg bg-background-200"></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}